/**
 * Created by Administrador on 22/08/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('productionByFlights', {
                parent: 'app',
                url: '/productionByFlights',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/production/productionByFlights.html',
                        controller: 'productionByFlightsCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['production']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabProduction('productionByFlights')
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            type:[function(){
                                return 'productionByFlights';
                            }]
                        }
                    }
                }
            })
            .state('flown', {
                parent: 'app',
                url: '/flown',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/production/productionByFlights.html',
                        controller: 'productionByFlightsCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['production']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabProduction('flown')
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            type:[function(){
                                return 'flown';
                            }]
                        }
                    }
                }
            })
            .state('notFlown', {
                parent: 'app',
                url: '/notFlown',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/production/productionByFlights.html',
                        controller: 'productionByFlightsCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['production']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabProduction('notFlown')
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            type:[function(){
                                return 'notFlown';
                            }]
                        }
                    }
                }
            });
    }
})();
